module.exports = {
    "container": "mc4ba0a608_container"
};